import { render, staticRenderFns } from "./Karaoke.vue?vue&type=template&id=8c2123d0&"
import script from "./Karaoke.vue?vue&type=script&lang=js&"
export * from "./Karaoke.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports